import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export default function Cryptochart() {
    let { id } = useParams();
    const [historicData, setHistoricData] = useState();
    const [days, setDays] = useState(1);

    function fetchData() {
        fetch(`https://api.coingecko.com/api/v3/coins/${id}/market_chart?vs_currency=inr&days=${days}`)
            .then(res => res.json())
            .then(data => {
                // console.log(data.prices)
                setHistoricData(data.prices)
            })
    }
    useEffect(() => {
        fetchData();
    }, [days])

    return (


        <div>
            <Line
                data={{
                    labels: historicData && historicData.map(item => {
                        let date = new Date(item[0]);
                        let time = date.getHours() > 12 ? `${date.getHours() - 12}:${date.getMinutes()} PM` : `${date.getHours()}: ${date.getMinutes()} AM`;

                        return days == 1 ? time : date.toLocaleDateString();
                    }),
                    datasets: [
                        {
                            label: `Price for Past ${days} days`,
                            // lineTension: 0.5,
                            // backgroundColor: 'rgba(75,192,192,1)',
                            borderColor: '#E4A11B',
                            borderWidth: 2,
                            data: historicData && historicData.map(item => item[1])
                        }
                    ]
                }}
                options={{
                    elements: {
                        point: {
                            radius: 1
                        }
                    },
                    title: {
                        display: true,
                        text: 'Historic Data',
                        fontSize: 20
                    },
                    legend: {
                        display: true,
                        position: 'right'
                    }
                }}
            />
            <div style={{marginTop:'100px'}} className='text-center'>
                <div className="btn-group" role="group" aria-label="Basic example">
                    <button onClick={()=> setDays(1)} type="button" className="btn btn-warning">1 DAY</button>
                    <button onClick={()=> setDays(30)} type="button" className="btn btn-warning">1 MONTH</button>
                    <button onClick={()=> setDays(90)} type="button" className="btn btn-warning">1 QUARTER</button>
                    <button onClick={()=> setDays(365)} type="button" className="btn btn-warning">1 YEAR</button>
                </div>
            </div>
            {/* <Line
                datasetIdKey='id'
                data={{
                    labels: ['Jun', 'Jul', 'Aug'],
                    datasets: [
                        {
                            id: 1,
                            label: '',
                            data: [5, 6, 7],
                        },
                        {
                            id: 2,
                            label: '',
                            data: [3, 2, 1],
                        },
                    ],
                }}
            /> */}
        </div>


    )
}
